import AppConfirmDialog from '@/components/AppConfirmDialog.vue';
import { confirmService } from '@/services/confirm';

export default {
  install(Vue) {
    Vue.component('AppConfirmDialog', AppConfirmDialog);
    Vue.prototype.$confirm = confirmService.confirm;
    Vue.$confirm = confirmService.confirm;
  },
};
